function r(n) {
  return n == null ? !1 : n.toString().match(/^[-+]?\d+\.?\d*$/) !== null;
}
function t(n) {
  return n === null ? "" : n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export {
  t as a,
  r as i
};
